import { Department, ServiceofDepartment } from "@/app/types/department";
import { apiSlice } from "@/features/api/ApiSlice";
export enum TicketStatus {
  SERVING = "serving",
  SERVED = "served",
  CANCELLED = "cancelled",
}
export interface TicketResponse {
  detail: string;
  data:string;
  time:string;
  title:string;
  description?:string;
  id: number;
  user_id: number;
  ticket_number: any;
  ticket_id:string;
  reserved_number: string;
  assigned_number: string;
  org_id: number;
  service_id: number;
  service_name: string;
  closing_time: string;
  counter_id: number;
  counter_code: string;
  status: TicketStatus; // Add other possible statuses if needed
  eta: number;
  feedback: string;
  created_at: string; // Alternatively, Date if parsing as Date object
  is_deleted: boolean;
}

interface TableResponse<T> {
  data: T[];
  total_count: number;
}

type KioskDepartments = TableResponse<Department>;

type SericeOfDepartment = TableResponse<ServiceofDepartment>;
export const Kiosk = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllkioskDepartment: builder.query<KioskDepartments, { query: string }>({
      query: ({ query }) => ({
        url: `/kiosk/departments${query.length > 0 ? `?${query}` : ""}`,
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      }),
      providesTags: ["Department"],
    }),
    getAllDepartmentServiceById: builder.query<
      SericeOfDepartment,
      { department_id: number; query: string }
    >({
      query: ({ department_id, query }) => ({
        url: `/kiosk/services/${department_id}${query.length > 0 ? `?${query}` : ""}`,
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      }),
      providesTags: ["Department"],
    }),

    generateTicketForService: builder.mutation<TicketResponse, number>({
      query: (serviceData) => {
        // Construct URL using URLSearchParams
        const now = new Date();

        // Convert to local date (YYYY-MM-DD)
        const localDate = new Date(
          now.getTime() - now.getTimezoneOffset() * 60000
        )
          .toISOString()
          .split("T")[0];

        // Format time correctly in 24-hour format (HH:mm:ss)
        const localTime = now.toLocaleTimeString("en-GB", {
          hourCycle: "h23",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        });

        const params = new URLSearchParams({
          title: " ",
          date: localDate, // Uses local date, not UTC
          time: localTime, // Uses properly formatted local time
          eta: "0",
        });
        // Final dynamic URL
        const requestUrl = `/kiosk/ticket/generate/${serviceData}?${params.toString()}`;
        return {
          url: requestUrl,
          method: "POST",
          headers: {
            Accept: "application/json",
          },
          body: {
            manual_eta: "0",
          },
        };
      },
      invalidatesTags: ["Ticket", "WaitingList"],
    }),

    generateUserTicketForService: builder.mutation<
      TicketResponse,
      {
        service_id: number;
        title: string;
        date: string;
        time: string;
        description?: string;
        user_id: number;
        r_ticket_id?: number;
        eta: number;
      }
    >({
      query: (serviceData) => {
        // Construct URL using URLSearchParams
        const params = new URLSearchParams({
          user_id: serviceData.user_id.toString(),
          title: serviceData.title,
          date: serviceData.date,
          time: `${serviceData.time}`, // Ensuring time format HH:mm:ss
          eta: serviceData.eta.toString(),
        });

        // Append optional parameters if they exist
        if (serviceData.description) {
          params.append("description", serviceData.description);
        }
        if (serviceData.r_ticket_id) {
          params.append("r_ticket_id", serviceData.r_ticket_id.toString());
        }

        // Final dynamic URL
        const requestUrl = `/kiosk/ticket/generate/${serviceData.service_id}?${params.toString()}`;

        return {
          url: requestUrl,
          method: "POST",
          headers: {
            Accept: "application/json",
          },
          body: {
            manual_eta: serviceData.eta,
          },
        };
      },
      invalidatesTags: ["Ticket", "WaitingList"],
    }),
  generateUserTicketFromservice: builder.mutation<
      TicketResponse,
      {
        service_id: number;
        title: string;
        date: string;
        time: string;
        is_admin: boolean;
        description?: string;
        user_id?: number;
        eta: number;
        counter:number;
        assigned_to?:string;
        status:string;
      }
    >({
      query: (serviceData) => {
        // Construct URL using URLSearchParams
        const params = new URLSearchParams({
          title: serviceData.title,
          date: serviceData.date,
          time: `${serviceData.time}`, // Ensuring time format HH:mm:ss
          eta: serviceData.eta.toString(),
          ticket_status: serviceData.status,
          is_admin: serviceData.is_admin ? "true" : "false",
        });

        // Append optional parameters if they exist
        if (serviceData.description) {
          params.append("description", serviceData.description);
        }
       
        if(serviceData.user_id){
          params.append("user_id", serviceData.user_id.toString());
        }

        // Final dynamic URL
        const requestUrl = `/kiosk/ticket/generate/${serviceData.service_id}?${params.toString()}`;

        return {
          url: requestUrl,
          method: "POST",
          headers: {
            Accept: "application/json",
          },
          body: {
            manual_eta: serviceData.eta,
            counter: serviceData.counter,
            ...(serviceData.assigned_to ? { assigned_to: serviceData.assigned_to } : {})
          },
        };
      },
      invalidatesTags: ["Ticket", "WaitingList"],
    }),
  }),
});

export const {
  useGetAllkioskDepartmentQuery,
  useGetAllDepartmentServiceByIdQuery,
  useLazyGetAllDepartmentServiceByIdQuery,
  useGenerateTicketForServiceMutation,
  useGenerateUserTicketForServiceMutation,
  useGenerateUserTicketFromserviceMutation
} = Kiosk;
